export default "__VITE_ASSET__e022940c__"